// Angular's own HttpErrorResponse#message is a generic diagnostic string ("Http failure
// response for <url>: <status> <statusText>"), never the server's real error message -- that
// lives in the parsed JSON body at error.error.message. Deliberately NOT falling back to
// error.message (matching sso.effects.ts's extractIamErrorMessage): that generic string embeds
// the full request URL, query string included, so it is internal diagnostic detail, not a message
// meant for an end user or for smash-telemetry's unauthenticated ingestion endpoint (D3) -- an
// unstructured/unhandled failure (network drop, 500 with no body) returns undefined instead. The
// access is optional-chained throughout: a rejection that is itself null/undefined must not throw
// here -- that would crash inside catchError and defeat the failure action entirely.
//
// `error` is deliberately `any`: every call site is an RxJS `catchError` callback, whose rejection
// has no narrower contract -- an HttpErrorResponse, a plain Error, or any other thrown/rejected
// value -- and this helper must extract a message from all of them without throwing. Every access
// below is already defensively optional-chained, so narrowing to `unknown` would need a type guard
// per shape for no added safety.
export function extractHttpErrorMessage(error: any): string | undefined {
    return error?.error?.message;
}
